import { useEffect, useRef, ReactNode } from "react";
import { inView } from "motion";

interface AnimatedSectionProps {
  children: ReactNode;
  className?: string;
  delay?: number;
}

export const AnimatedSection = ({ 
  children, 
  className = "", 
  delay = 0 
}: AnimatedSectionProps) => {
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!ref.current) return;

    const element = ref.current;

    // Animate when in view using Motion One's inView
    const stopInView = inView(
      element,
      () => {
        element.style.transition = `all 0.5s cubic-bezier(0.25, 0.1, 0.25, 1) ${delay}s`;
        element.style.opacity = "1";
        element.style.transform = "scale(1)";
      },
      { margin: "-100px" }
    );

    return () => {
      if (typeof stopInView === 'function') {
        stopInView();
      }
    };
  }, [delay]);

  return (
    <div ref={ref} className={className} style={{ opacity: 0, transform: "scale(0.95)", willChange: "opacity, transform" }}>
      {children}
    </div>
  );
};
